import request from '@/utils/request'
import { TOKEN_KEY } from '@/config/api'

// 注册接口
export function register(data) {
  // 将数据转换为x-www-form-urlencoded格式
  const params = new URLSearchParams()
  params.append('username', data.username)
  params.append('password', data.password)
  if (data.contact) {
    params.append('contact', data.contact)
  }
  
  return request({
    url: '/register',
    method: 'post',
    data: params
  })
}

// 登录接口
export function login(data) {
  // 将数据转换为x-www-form-urlencoded格式
  const params = new URLSearchParams()
  params.append('username', data.username)
  params.append('password', data.password)
  
  return request({
    url: '/login',
    method: 'post',
    data: params
  })
}

// 保存token到localStorage
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

// 从localStorage获取token
export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

// 清除token
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

// 检查是否已登录
export function isLoggedIn() {
  return !!getToken()
}

